export const UPDATE_LIST = 'UPDATE_LIST';
export const UPDATE = 'UPDATE_LIST_FLAG';
export const UPDATE_BOUNDARIES = 'UPDATE_BOUNDARIES';
